<template>
  <div>
    <el-form :model="queryForm"
             :rules="queryFormRules"
             ref="queryFormRef"
             label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="服务平台"
                        prop="platform">
            <el-select v-model="platform"
                      placeholder="请选择要查询的key"
                      @change="getKeyList">
              <el-option  v-for="item in platformList"
                          :key="item.code"
                          :label="item.name"
                          :value="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="Key"
                        prop="key">
            <el-select v-model="queryForm.key"
                       placeholder="请选择要查询的key"
                       style="width:410px"
                       @change="getApiList">
              <el-option v-for="item in keyOptionList"
                         :key="item.key"
                         :label="item.keyName+'//'+item.key"
                         :value="item.key"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接口"
                        prop="api">
            <el-select v-model="queryForm.api"
                       placeholder="请选择要查询接口"
                       style="width:160px">
              <el-option v-for="item in apiList"
                         :key="item.api"
                         :label="item.apiName"
                         :value="item.api"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item prop="timeType"
                        label="时间区间">
            <el-radio-group v-model="queryForm.timeType">
              <el-radio v-if="activeTable==='2'"
                        :label="1">本小时</el-radio>
              <el-radio :label="2">本天</el-radio>
              <el-radio :label="3">本周</el-radio>
              <el-radio :label="4">自定义</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8"
                style="border: 1px solid transparent">
          <el-date-picker style="width:380px"
                          v-model="timeRange"
                          type="daterange"
                          unlink-panels
                          align="center"
                          v-if="queryForm.timeType ===4"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          :default-time="['00:00:00', '23:59:59']"
                          :picker-options="pickerOptions"
                          value-format="timestamp">
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-button style="width:100px"
                     type="primary"
                     @click="queryInfo">查询</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeTable"
             @tab-click="clearTable"
             stretch>
      <el-tab-pane label="调用量"
                   name="1">
        <el-table :data="doseData"
                  v-loading="loadingDoseData"
                  style="width: 100%">
          <el-table-column prop="keyName"
                           width="180"
                           label="key名称">
          </el-table-column>
          <el-table-column prop="key"
                           label="key">
          </el-table-column>
          <el-table-column prop="platformName"
                           width="150"
                           label="服务平台名称">
          </el-table-column>
          <el-table-column prop="apiName"
                           width="150"
                           label="接口名称">
          </el-table-column>
          <el-table-column prop="topValue"
                           width="130"
                           label="上限">
          </el-table-column>
          <el-table-column prop="overrunTime"
                           width="170"
                           :formatter="formatDate"
                           label="超限开始时间">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="QPS"
                   name="2">
        <el-table :data="qpsData"
                  v-loading="loadingQpsData"
                  style="width: 100%">
          <el-table-column prop="keyName"
                           width="180"
                           label="key名称">
          </el-table-column>
          <el-table-column prop="key"
                           label="key">
          </el-table-column>
          <el-table-column prop="platformName"
                           label="服务平台名称">
          </el-table-column>
          <el-table-column prop="apiName"
                           label="接口名称">
          </el-table-column>
          <el-table-column prop="overrunCount"
                           width="100"
                           label="超限次数">
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>

import http from '@/http/index.js'

// import { cloneDeep } from 'lodash';
import queryKey from '../mixins/queryKey.js'
import queryApiList from '../mixins/queryApiList'

export default {
  mixins: [queryKey, queryApiList],
  data() {
    return {
      pickerOptions: {
        disabledDate(date) {
          const end = new Date( // 当天23:59
            new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 - 1
          );
          return (
            (date.getTime() >= end.getTime() - 86400000) ||
            (date.getTime() <= end.getTime() - 90 * 86400000)
          );
        }
      },
      queryForm: {
        key: null,
        api: null,
        timeType: 2,
        start: null,
        end: null
      },
      loadingQpsData: false,
      loadingDoseData: false,
      timeRange: [],
      activeTable: '1',
      queryFormRules: {
        key: [{ required: true, message: '请选择Key', trigger: 'blur' }],
        api: [{ required: true, message: '请选择接口', trigger: 'blur' }],
        timeType: [
          { required: true, message: '请选择查询时间范围', trigger: 'blur' }
        ]
      },
      // dataRules: [{ required: true, message: '请选择自定义时间' }],
      doseData: null,
      qpsData: null
    };
  },
  methods: {
    async queryInfo() {
      this.$refs.queryFormRef.validate(async (valid) => {
        if (!valid) return;
        // 发起查询表格请求
        if (this.activeTable === '1') {
          // 调用量查询
          this.loadingDoseData = true
          this.doesQuery();
        } else {
          this.loadingQpsData = true
          this.qpsQuery();
        }
      });
    },
    async doesQuery() {
      if (this.queryForm.timeType === 4) {
        if (this.timeRange === null) {
          this.$message.error('请输入自定义时间范围');
        } else {
          this.queryForm.start = this.timeRange[0] / 1000;
          this.queryForm.end = this.timeRange[1] / 1000;
        }
      }
      const res = await http.flow.doseQuery(this.queryForm);
      this.loadingDoseData = false
      this.doseData = res;
    },
    async qpsQuery() {
      if (this.queryForm.timeType === 4) {
        if (this.timeRange === null) {
          this.$message.error('请输入自定义时间范围');
        } else {
          this.queryForm.start = this.timeRange[0];
          this.queryForm.end = this.timeRange[1];
        }
      }
      const res = await http.flow.qpsQuery(this.queryForm);
      this.loadingQpsData = false
      this.qpsData = res;
    },
    clearTable() {
      if (this.activeTable === '1' && this.queryForm.timeType === 1) {
        this.queryForm.timeType = 2
      }
      this.queryInfo();
    },
    formatDate(row, column, cellValue, index) {
      if (cellValue == null || cellValue === '') return '';
      let date = new Date(parseInt(cellValue) * 1000);
      let Y = date.getFullYear() + '-';
      let M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-';
      let D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':';
      let m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':';
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    }
  }
};
</script>

<style scoped lang="less">
/*去掉el-tab-pane底部灰色线条*/
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

/deep/ .el-tabs__nav-scroll {
  width: 200px !important;
  margin: 0 auto !important;
}
/deep/.el-tabs__item {
  padding: 0 !important;
  border: 1px solid rgba(0, 0, 0, 0.3);
  margin-right: 5px;
}
/deep/.el-tabs__item.is-active {
  color: #fff;
  background-color: #18a6d3;
}
/deep/ .el-tabs__active-bar {
  background-color: transparent !important;
}
</style>
